import { render, staticRenderFns } from "./TextInformativeModalEmployee.vue?vue&type=template&id=6297f613&scoped=true&"
import script from "./TextInformativeModalEmployee.vue?vue&type=script&lang=js&"
export * from "./TextInformativeModalEmployee.vue?vue&type=script&lang=js&"
import style0 from "./TextInformativeModalEmployee.vue?vue&type=style&index=0&id=6297f613&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6297f613",
  null
  
)

export default component.exports